import { PageSource } from '@mc/track-event'

export const CM_INNOVATIVE_SWING_FLAG_NAME = 'pen-5613_v1'

export const ANCHORS = {
  JOURNEY: 'journey',
  REVIEWS: 'reviews',
  CLASS: 'class',
}

export const PAGE_SOURCE = PageSource.LOGGED_OUT_CLASS
